var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33333 14.5C2.96667 14.5 2.65289 14.3696 2.392 14.1087C2.13111 13.8478 2.00044 13.5338 2 13.1667V3.83333C2 3.46667 2.13067 3.15289 2.392 2.892C2.65333 2.63111 2.96711 2.50044 3.33333 2.5H8V3.83333H3.33333V13.1667H8V14.5H3.33333ZM10.6667 11.8333L9.75 10.8667L11.45 9.16667H6V7.83333H11.45L9.75 6.13333L10.6667 5.16667L14 8.5L10.6667 11.8333Z",
    fill: "#282828"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/logout-icon.19410a73414fcf5234572c5e691ca0a3.svg";
export { ForwardRef as ReactComponent };